import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from 'src/app/shared/upload.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { RegistroBicicleta } from 'src/app/models/registroBicicleta.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VehiculoFuncionario } from 'src/app/models/administrarFuncionario.model';

@Component({
    selector: 'consultar-funcionario-bicicleta',
    templateUrl: './consultar-funcionario-bicicleta.component.html',
    styleUrls: ['./consultar-funcionario-bicicleta.component.scss']
})
export class ConsultarFuncionarioBicicletaComponent implements OnInit {

    isOpen = false;

    codigoBarras: string;
    numeroDocumento: string;
    registroBicicleta: RegistroBicicleta;
    busqueda = false;
    informacionFuncionario = false;
    public urlFTP;
    sede = false;
    urlFotoFuncionario: string;
    registrarEntrada = false;
    registrarSalida = false;
    public listaVehiculos: VehiculoFuncionario[] = [];
    public sedes: DetalleDominio[] = [];
    public mediosTransporte: DetalleDominio[] = [];
    public listaParametros: string[] = [DominiosService.DOMINIO_SEDE];
    sedeSeleccionada: string;
    medioTransporteSeleccionado: string;
    estadosBicicleta: DetalleDominio[] = [];
    observaciones: string;
    descripcionOtro = "";
    vehiculoSeleccionado: any;
    informacionVehiculo: boolean;

    constructor(
        private uploadService: UploadService, private alertService: AlertService,
        private urlService: UrlService,
        private router: Router, private route: ActivatedRoute,
        private utilService: UtilService,
        private spiner: NgxSpinnerService,
        private global: GlobalService) {

        this.urlFTP = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
    }
    // tslint:disable: triple-equals

    ngOnInit(): void {
		this.init();
    }

	init(){
		this.spiner.show();
        this.consultarEstadosBicicleta(DominiosService.DOMINIO_ESTADOS_BICICLETA);
	}

    consultarEstadosBicicleta(dominio) {
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', dominio]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            (data: DetalleDominio[]) => {
                this.estadosBicicleta = data;
                this.cargarParametros('Sede');
                this.cargarParametros('TipoVehiculo');
            }, err => {
                this.cathException(err.error.message, err);
            }
        );

    }

    cargarParametros(filtro) {

        this.sedeSeleccionada = sessionStorage.getItem('sedeDefectoSession');

        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            (data: DetalleDominio[]) => {
                if (filtro === 'Sede') {
                    this.sedes = data;
                    this.sede = true;
                } else if (filtro === 'TipoVehiculo') {
                    this.mediosTransporte = data;
                }

                this.spiner.hide();
            }, err => {
                this.cathException(err.error.message, err);
            }
        );
    }

    obtenerEstadoBicicleta(nombreDetalleDominioEstado) {

            return this.estadosBicicleta.find(x => x.detalleDominioPK.nombreDetalleDominio == nombreDetalleDominioEstado).valor;
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la consulta de vehiculos
     */
         consultarVehiculos(tipoDocumento,numDocumento) {
            //this.spinner.show();
            const serviceProvider = 'consultarVehiculos';
            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push([
                'filterBy',
                this.urlService.encodeURI('tipoIdFuncionario=' +  tipoDocumento
                    + '&' + 'numeroIdFuncionario=' +  numDocumento)]);
            let url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null,
                queryParams), this.urlService.hostAPI_FUNCIONARIOS);
            url = url + '&orderBy=ordenVehiculo$DESC';
            this.global.getGenerico(url).subscribe(
                data => {
                    if(data.length==0){
                        this.alertService.generateAlertError('El funcionario no posee vehículos asociados',"Error");
                        this.busqueda = true;
                        return;
                    }
                    let dato = this.mediosTransporte.filter(x => x.detalleDominioPK.nombreDetalleDominio == this.medioTransporteSeleccionado);
                    let info =dato[0].valor.toUpperCase();
                    //let medio = this.medioTransporteSeleccionado;
                    let medio = info;
                    if(medio==="BICI"){
                        medio="BICICLETA";
                    }
                    this.informacionVehiculo = false;
                    this.listaVehiculos = data;

                    this.vehiculoSeleccionado = data.find(f=>f.tipoVehiculo === medio)
                    if(!this.vehiculoSeleccionado){
                    this.alertService.generateAlertError('El funcionario no posee un vehículo de este tipo asociado'
                    , 'Error');
                    this.busqueda = true;
                    }else{
                        this.informacionVehiculo = true;
                        this.registroBicicleta.placa = this.vehiculoSeleccionado.placa;
                        this.busqueda = false;
                    }
              //      this.spinner.hide();
                }, err => {
                    this.utilService.cathException('No fue posible Cargar los vehiculos', this.alertService, undefined);
                }
            );
        }
    obtenerEstadoMediosDeTransporte(nombreDetalleDominioEstado) {
        if (this.medioTransporteSeleccionado) {
            let dato = this.mediosTransporte.filter(x => x.detalleDominioPK.nombreDetalleDominio == this.medioTransporteSeleccionado);
            let info =dato[0].valor;

            return info;
        } else   if (nombreDetalleDominioEstado) {
            return this.mediosTransporte.find(x => x.detalleDominioPK.nombreDetalleDominio == nombreDetalleDominioEstado).valor;
        } else {
            return '';
        }
    }

    seleccionarSede(sede) {
        this.sedeSeleccionada = sede;

    }

    seleccionarMedioTransporte(medioTransporte) {
        this.medioTransporteSeleccionado = medioTransporte;

        if (medioTransporte === 'OTRO') {
            this.openOverlay();
        }
    }

    buscarFuncionario() {
        console.log(this.sedeSeleccionada);

        this.sede = false;
        this.busqueda = true;
    }

	buscarFuncionarioVolver(){
		this.redirectTo('/main/consultar-funcionario-bicicleta');
	}

	redirectTo(uri:string){
	   this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
	   this.router.navigate([uri]));
	}

    openOverlay() {
        this.isOpen = true;
    }

    closeOverlay() {
        this.isOpen = false;
    }

    guardarOtro() {
        this.isOpen = false;
    }


    /**
     * Catch que genera una alerta en el componente cuando hay errores
     * @param err
     * @author
     */
    cathException(err, error) {
        console.log(error);
        this.spiner.hide();
        this.alertService.generateAlertError(err, '');
    }

    transformarCodigoBarrasANumeroDocumento() {
        // Formato codigo barras (XX-XXXXXXXXXX-X) Identificador bicicleta- numero documento - id barras
        if (this.codigoBarras.length === 10 || this.codigoBarras.length === 8) {
            return this.codigoBarras;
        } else if (this.codigoBarras.length === 13) {
            this.numeroDocumento = this.codigoBarras.substring(2, this.codigoBarras.length);
            let identificadorCedula;
            if (this.numeroDocumento.length === 11) {
                identificadorCedula = this.codigoBarras.substring(2, 4);
            } else if (this.numeroDocumento.length === 10) {
                identificadorCedula = this.codigoBarras.substring(2, 3);
            }
            if (identificadorCedula == '00') {
                this.numeroDocumento = this.numeroDocumento.substring(2, this.numeroDocumento.length - 1);
            } else if (identificadorCedula == '0') {
                this.numeroDocumento = this.numeroDocumento.substring(1, this.numeroDocumento.length - 1);
            } else {
                this.numeroDocumento = this.numeroDocumento.substring(0, this.numeroDocumento.length - 1);
            }
            this.numeroDocumento = this.numeroDocumento.replace(/^(0+)/g, '');
            return this.numeroDocumento;
        } else {
            return '';
        }
    }

    consultarFuncionario() {
        this.spiner.show();
        this.busqueda = false;
        if (!this.utilService.validarCamposObligatorios(this.medioTransporteSeleccionado)) {
            this.spiner.hide();
            this.busqueda = true;
            return this.alertService.generateAlertError('Por favor seleccione el medio de transporte para realizar la búsqueda'
                , 'Error');
        }else  if (!this.utilService.validarCamposObligatorios(this.codigoBarras)) {
            this.spiner.hide();
            this.busqueda = true;
            return this.alertService.generateAlertError('Por favor ingresar código de barras para realizar la búsqueda'
                , 'Error');
        } else {
            this.numeroDocumento = this.transformarCodigoBarrasANumeroDocumento();
            if (this.numeroDocumento.length > 5 && this.numeroDocumento.length < 11) {
            const serviceProvider = 'validarCodigoFuncionarioBicicleta';
            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['numeroDocumento', this.urlService.encodeURI(this.numeroDocumento)]);
            const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
                this.urlService.hostAPI_FUNCIONARIOS);
            this.global.postGenerico(url).subscribe(
                (data: RegistroBicicleta) => {


                    this.registroBicicleta = data;
                    if(this.medioTransporteSeleccionado!=="OTRO"){
                        //this.consultarVehiculos("CC",data.numeroDocumento)
                        this.consultarVehiculos(data.tipoIdFuncionario,data.numeroDocumento)

                    }else{
                        this.informacionVehiculo=true;
                        this.registroBicicleta.placa = "";
                    }
                    this.urlFotoFuncionario = this.obtenerUrlFoto(this.registroBicicleta.urlFoto);
                    if ((this.registroBicicleta.estadoBicicleta == DominiosService.ESTADO_BICICLETA_INGRESADA) ||
                        (this.registroBicicleta.estadoBicicleta == DominiosService.ESTADO_BICICLETA_NO_SALIDA)) {
                        this.registrarSalida = true;
                    } else if ((this.registroBicicleta.estadoBicicleta == DominiosService.ESTADO_BICICLETA_NO_INGRESO) ||
                        (this.registroBicicleta.estadoBicicleta == DominiosService.ESTADO_BICICLETA_RETIRADA)) {
                        this.registrarEntrada = true;
                        this.registroBicicleta.placa = null;
                    }
                    this.spiner.hide();
                    this.informacionFuncionario = true;


                }, err => {
                    this.busqueda = true;
                    this.informacionFuncionario = false;
                    this.informacionVehiculo = false;
                    this.spiner.hide();
                    this.cathException(err.error.message, err);
                });
            } else {
                this.busqueda = true;
                this.spiner.hide();
                this.informacionFuncionario = false;
                this.informacionVehiculo = false;
                this.alertService.generateAlertError('El código de barras no tiene el formato correcto'
                , 'Error');
            }
        }
    }

    /**
     * Metodo encargado de colocar la foto de la persona o en dicha caso que no tenga
     * coloca la foto por defecto
     */
    public obtenerUrlFoto(url: string): string {
        if (this.urlFTP && this.urlFTP !== '' && url) {
            return this.urlFTP + url;
        } else {
            return 'assets/img/user-male-icon.png';
        }
    }


    registrarEntradaFuncionario() {
        this.spiner.show();
        const serviceProvider = 'registrarIngresoFuncionarioBicicleta';
        this.registroBicicleta.idFuncionario = sessionStorage.getItem('sia3Session');
        this.registroBicicleta.sede = this.sedeSeleccionada;
        this.registroBicicleta.observaciones = this.observaciones;
        this.registroBicicleta.medioTransporte = this.medioTransporteSeleccionado;
        this.registroBicicleta.otro = this.descripcionOtro;
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, this.registroBicicleta).subscribe(
            (data) => {
                this.alertService.generateAlertSuccess('Se registró ingreso de medio de transporte exitosamente', '');
                this.registrarEntrada = false;
                this.registrarSalida = true;
                this.spiner.hide();
                // this.consultarFuncionario();
                this.informacionFuncionario = false;
                this.informacionVehiculo = false;
                this.codigoBarras = '';
                this.numeroDocumento = '';
            }, err => {
                this.spiner.hide();
                this.cathException(err.error.message, err);
            });
    }

    registrarSalidaFuncionario() {
        this.spiner.show();
        const serviceProvider = 'registrarSalidaFuncionarioBicicleta';
        this.registroBicicleta.idFuncionario = sessionStorage.getItem('sia3Session');
        this.registroBicicleta.sede = this.sedeSeleccionada;
        this.registroBicicleta.observaciones = this.observaciones;
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, this.registroBicicleta).subscribe(
            (data) => {
                this.alertService.generateAlertSuccess('Se registró salida de medio de transporte exitosamente', '');
                this.registrarSalida = false;
                this.registrarEntrada = true;
                this.spiner.hide();
                // this.consultarFuncionario();
                this.informacionFuncionario = false;
                this.informacionVehiculo = false;
                this.codigoBarras = '';
                this.numeroDocumento = '';
            }, err => {
                this.spiner.hide();
                this.cathException(err.error.message, err);
            });
    }

    volver() {
        this.busqueda = true;
        this.informacionFuncionario = false;
        this.registroBicicleta=null;
        this.observaciones="";
        this.registrarSalida = false;
        this.registrarEntrada = false;
    }

}
